var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 42.009 42.009"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 3,
    d: "M40.1 14.446L28.95 1.963a1.267 1.267 0 00-1.959 0 1.594 1.594 0 00-.414 1.1v6.239H21.7q-15.522 0-19.048 9.826A24.626 24.626 0 001.5 27.247q0 4.047 2.765 11 .065.171.228.585t.294.731a2.858 2.858 0 00.283.529.735.735 0 00.61.415.607.607 0 00.512-.244.98.98 0 00.185-.609 5.544 5.544 0 00-.055-.646 5.631 5.631 0 01-.055-.573q-.109-1.657-.109-3a23.162 23.162 0 01.381-4.413A14.332 14.332 0 017.6 27.649a8.4 8.4 0 011.742-2.462 10.2 10.2 0 012.3-1.694 11.526 11.526 0 012.9-1.036 24.835 24.835 0 013.352-.524q1.687-.146 3.821-.146h4.876v6.242a1.593 1.593 0 00.413 1.1 1.268 1.268 0 001.96 0L40.1 16.641a1.663 1.663 0 000-2.195z"
  })));
};
export default SvgShare;